import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import VirtualStore from "@/pages/VirtualStore";
import Home from "@/pages/Home";
import MembersHome from "@/pages/MembersHome";
import Shop from "@/pages/Shop";
import Policies from "@/pages/Policies";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Preorder from "@/pages/Preorder";

const AnimatedRoutes = () => {
  const location = useLocation();
  const isStore = location.pathname === "/";
  return (
    <div className="flex min-h-screen flex-col">
      {!isStore && <SiteHeader />}
      <div className="flex-1">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<VirtualStore />} />
            <Route path="/home" element={<Home />} />
            <Route path="/members" element={<MembersHome />} />
            <Route path="/shop" element={<Shop title="Shop" />} />
            <Route path="/t-shirts" element={<Shop title="T-shirts" />} />
            <Route path="/long-sleeves" element={<Shop title="Long Sleeves" />} />
            <Route path="/hoodies" element={<Shop title="Hoodies" />} />
            <Route path="/tops" element={<Shop title="Tops" />} />
            <Route path="/bottoms" element={<Shop title="Bottoms" />} />
            <Route path="/accessories" element={<Shop title="Accessories" />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/preorder" element={<Preorder />} />
          </Routes>
        </AnimatePresence>
      </div>
      {!isStore && <SiteFooter />}
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
